import { Directive, ElementRef, OnDestroy, OnInit } from "@angular/core";

@Directive({
  selector: "[loadingDots]",
})
export class LoadingDotsDirective implements OnInit, OnDestroy {
  private intervalId: any;
  private dots: string[] = ["", ".", "..", "..."];
  private currentIndex: number = 0;

  constructor(private el: ElementRef) {}

  ngOnInit(): void {
    let flag = false;
    let content = "";
    this.intervalId = setInterval(() => {
      if (!flag) {
        content = this.el.nativeElement.textContent;
        flag = true;
      }

      this.el.nativeElement.textContent = content + this.dots[this.currentIndex];
      this.currentIndex = (this.currentIndex + 1) % this.dots.length;
    }, 300);
  }

  ngOnDestroy(): void {
    clearInterval(this.intervalId);
  }
}
